export const WEBHOOK_SUBSCRIPTIONS_QUERY_KEY = "webhook-subscriptions:list";
export const SAVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY = "webhook-subscriptions:save";
export const REMOVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY = "webhook-subscriptions:remove";
export const TEST_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY = "webhook-subscriptions:test";
export const WEBHOOK_SUBSCRIPTIONS_TOGGLE_MUTATION_KEY = "webhook-subscriptions:toggle";
